import type { FC, ReactNode } from 'react'
import type { Settings } from '@/types/content'

import { ButtonLink } from '@/components/generals/button-link'
import { cms } from '@/lib/cms'

interface CtaButtonProps {
    settings: Settings
    href?: string
    tone?: 'light' | 'dark'
    size?: 'md' | 'lg'
    className?: string
    onClick?: () => void
}

// The site-wide conversion call to action. Its label is edited once in the settings collection.
export const CtaButton: FC<CtaButtonProps> = ({
    settings,
    href = '/kontakt',
    tone = 'light',
    size = 'md',
    className,
    onClick
}): ReactNode => {
    return (
        <ButtonLink
            href={href}
            label={settings.cta_text}
            labelCms={cms('einstellungen', settings.id, 'cta_text')}
            tone={tone}
            size={size}
            className={className}
            onClick={onClick}
        />
    )
}
